"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.match");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _tradeBanner = _interopRequireDefault(require("../../components/trade/trade-banner.vue"));
var _rightNav = _interopRequireDefault(require("../../components/trade/right-nav.vue"));
var _appCitysData = _interopRequireDefault(require("@/assets/static/js/citys/app.citys.data.js"));
var _footNav = _interopRequireDefault(require("../../components/foot-nav"));
var _api = _interopRequireWildcard(require("../../api/api"));
var _relativeTime = require("../../assets/static/js/utils/relativeTime.js");
var _cookie = require("@/assets/static/js/utils/cookie.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _default = exports.default = {
  name: 'pubcars',
  components: {
    tradeBanner: _tradeBanner.default,
    rightNav: _rightNav.default,
    footNav: _footNav.default
  },
  data: function data() {
    var _this = this;
    // 参考价格校验
    var priceRule = function priceRule(rule, value, callback) {
      if (value != '' && parseInt(value) < parseInt(_this.pubForm.minPrice)) {
        callback(new Error('请输入正确的参考价格'));
      } else {
        callback();
      }
    };
    return {
      checked: false,
      ctype: [],
      //车辆类型
      vesselType: [],
      //承接类型
      handingway: [],
      // isempty: Boolean, //控制发布按钮
      pubForm: {
        vsOrigin: [],
        //起始地
        vsDestination: [],
        //目的地
        vsContact: '',
        //联系人
        vsCellphone: '',
        //联系电话
        vsSetOutTime: '',
        //装车时间
        vsTypeCode: '',
        //长期路线
        loadSourceCode: '',
        //装卸方式
        minPrice: null,
        //参考价格-最低
        topPrice: null,
        //参考价格-最高
        vsRemark: '',
        //备注
        sourceTypeId: '4',
        //来源类型(固定4)
        vehicleNumber: '',
        //车牌号
        cVehicleTypeId: '',
        //车辆类型
        vehicleLength: '',
        //车辆长度
        vehicleLoadWeight: '',
        //核定载重
        vesselGoodsType: [] //承接类型
      },
      // 表单校验
      pubRules: {
        vsOrigin: [{
          required: true,
          message: '请选择出发城市',
          trigger: 'change'
        }],
        vsDestination: [{
          required: true,
          message: '请选择到达城市',
          trigger: 'change'
        }],
        vsContact: [{
          required: true,
          message: '请填写联系人',
          trigger: 'blur'
        }],
        vsCellphone: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }, {
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        vsSetOutTime: [{
          type: 'date',
          required: true,
          message: '请选择装车时间',
          trigger: 'change'
        }],
        topPrice: [{
          validator: priceRule,
          trigger: 'blur'
        }],
        cVehicleTypeId: [{
          required: true,
          message: '请选择车辆类型',
          trigger: 'change'
        }]
      },
      //表单校验
      start: '',
      end: '',
      startCitys: _appCitysData.default.cityData,
      //出发城市数据
      endCitys: _appCitysData.default.cityData,
      //出发城市数据
      rightAdverData: [],
      //右侧广告

      tabList: [{
        name: '货源查询',
        url: 'goods'
      }, {
        name: '车源查询',
        url: 'cars'
      }, {
        name: '发布车源',
        url: 'pubcars'
      }, {
        name: '发布货源',
        url: 'pubgoods'
      }]
    };
  },
  computed: {
    isPubCards: function isPubCards() {
      if (this.$route.name == 'pubcars') {
        return true;
      } else {
        return false;
      }
    },
    typeCode: function typeCode() {
      return this.checked ? '10' : '20';
    },
    isempty: {
      get: function get() {
        var that = this,
          flag = true;
        if (that.pubForm.vsOrigin.length > 0 && that.pubForm.vsDestination.length > 0 && that.pubForm.vsContact && that.pubForm.vsCellphone && that.pubForm.cVehicleTypeId) {
          flag = false;
        }
        return flag;
      },
      // 表单验证时候,有对这个计算属性直接赋值的操作.不写set,会报错
      // 因为vue的计算属性默认有get,没有set
      set: function set(newValue) {
        return newValue;
      }
    }
  },
  created: function created() {
    this.toLogin();
    // 表单内容的回填
    if (sessionStorage.getItem('pubCarsForm')) Object.assign(this.pubForm, JSON.parse(sessionStorage.getItem('pubCarsForm')));
    this.loadAdvertiseData(); //右侧广告
    this.getCarType(); //车辆类型
    // this.getVesselGoodsType() //承接类型
    this.getLoadSourceCode(); //装卸方式
  },
  beforeRouteLeave: function beforeRouteLeave(to, form, next) {
    // 页面离开前将缓存清除,以免影响下次的发布货源
    sessionStorage.removeItem('pubCarsForm');
    next();
  },
  methods: {
    //获取广告
    loadAdvertiseData: function () {
      var _loadAdvertiseData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, userInfo, _yield$Api$apiGetAdve, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              that = this; // session替换成cookie
              userInfo = (0, _cookie.getCookie)('user') ? JSON.parse((0, _cookie.getCookie)('user')) : ''; // var userInfo = JSON.parse(window.sessionStorage.getItem('user'))
              _context.next = 4;
              return _api.default.apiGetAdvertiseData({
                showType: 'PC_VS_RELEASE',
                userId: userInfo ? userInfo.usid : ''
              });
            case 4:
              _yield$Api$apiGetAdve = _context.sent;
              data = _yield$Api$apiGetAdve.data;
              that.rightAdverData = data.proData.filter(function (item) {
                return item.showPosition != 'CENTER';
              });
              that.centerAdvertise = data.proData.filter(function (item) {
                return item.showPosition.match('CENTER');
              });
              //  console.log('adverdata:', that.rightAdverData)
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadAdvertiseData() {
        return _loadAdvertiseData.apply(this, arguments);
      }
      return loadAdvertiseData;
    }(),
    //选择出发城市
    startCityChange: function startCityChange(value) {
      var that = this;
      if (value.length > 0 && (value[0].indexOf('台湾') >= 0 || value[0].indexOf('香港特别行政区') >= 0 || value[0].indexOf('澳门特别行政区') >= 0 || value[0].indexOf('钓鱼岛') >= 0)) {
        that.$message({
          message: '该地区业务还未开展',
          type: 'warning'
        });
        that.pubForm.vsOrigin = [];
        value = [];
        return;
      }
      var startStr = value.join('/');
      that.start = startStr.replace(/\/全省/g, '');
      that.start = startStr.replace(/\/全市/g, '');
      //  console.log("start:", that.start);
    },
    //选择到达城市
    endCityChange: function endCityChange(value) {
      var that = this;
      if (value.length > 0 && (value[0].indexOf('台湾') >= 0 || value[0].indexOf('香港特别行政区') >= 0 || value[0].indexOf('澳门特别行政区') >= 0 || value[0].indexOf('钓鱼岛') >= 0)) {
        that.$message({
          message: '该地区业务还未开展',
          type: 'warning'
        });
        that.pubForm.vsDestination = [];
        value = [];
        return;
      }
      var endStr = value.join('/');
      that.end = endStr.replace(/\/全省/g, '');
      that.end = endStr.replace(/\/全市/g, '');
      //  console.log("end:", that.end);
    },
    // 获取车辆类型
    getCarType: function () {
      var _getCarType = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, _yield$Api$apiGetCarT, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              _context2.next = 3;
              return _api.default.apiGetCarTypeData();
            case 3:
              _yield$Api$apiGetCarT = _context2.sent;
              data = _yield$Api$apiGetCarT.data;
              if (data.proCode == '200') {
                that.ctype = data.proData;
                that.ctype = that.ctype.filter(function (item) {
                  if (item.vehicleTypeName != '不限') {
                    return item;
                  }
                });
              } else {
                //  console.log(data.proMsg)
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getCarType() {
        return _getCarType.apply(this, arguments);
      }
      return getCarType;
    }(),
    // 获取承接类型
    getVesselGoodsType: function () {
      var _getVesselGoodsType = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, param, _yield$Api$apiGetDicD, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              that = this;
              param = {
                dicttypekey: "VEHICLE_RECEIVE"
              };
              _context3.next = 4;
              return _api.default.apiGetDicData(param);
            case 4:
              _yield$Api$apiGetDicD = _context3.sent;
              data = _yield$Api$apiGetDicD.data;
              if (data.code == '200') {
                that.vesselType = data.datalist;
              } else {
                //  console.log(data.msg)
              }
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getVesselGoodsType() {
        return _getVesselGoodsType.apply(this, arguments);
      }
      return getVesselGoodsType;
    }(),
    // 获取装卸方式
    getLoadSourceCode: function () {
      var _getLoadSourceCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, param, _yield$Api$apiGetDicD2, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              that = this;
              param = {
                dicttypekey: "LOAD_SOURCE_CODE"
              };
              _context4.next = 4;
              return _api.default.apiGetDicData(param);
            case 4:
              _yield$Api$apiGetDicD2 = _context4.sent;
              data = _yield$Api$apiGetDicD2.data;
              if (data.code == '200') {
                that.handingway = data.datalist;
              }
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getLoadSourceCode() {
        return _getLoadSourceCode.apply(this, arguments);
      }
      return getLoadSourceCode;
    }(),
    // 立即发布
    toPubCars: function toPubCars(formName) {
      var _this2 = this;
      // session替换成cookie
      var userStorage = (0, _cookie.getCookie)('user');
      var userToken = (0, _cookie.getCookie)('token');
      // let userStorage = window.sessionStorage.getItem('user')
      if (!userStorage || !userToken) {
        // 为解决发布时再登录的情况下,页面刷新导致的表单内容丢失问题
        sessionStorage.setItem('pubCarsForm', JSON.stringify(this.pubForm));
        this.$root.dialogFormVisible = true;
      } else {
        this.$refs[formName].validate(function (valid) {
          console.log('valid', valid);
          if (!valid) {
            return false;
          } else {
            _this2.pubForm.vsTypeCode = _this2.typeCode;
            var param = JSON.parse(JSON.stringify(_this2.pubForm));
            param.vsSetOutTime = (0, _relativeTime.formatDate)(param.vsSetOutTime, 'yyyy/MM/dd hh:mm:ss');
            param.vsDestination = param.vsDestination.join('/');
            param.vsOrigin = param.vsOrigin.join('/');
            param.vsDestination = param.vsDestination.replace(/\/全省/g, '');
            param.vsDestination = param.vsDestination.replace(/\/全市/g, '');
            param.vsOrigin = param.vsOrigin.replace(/\/全省/g, '');
            param.vsOrigin = param.vsOrigin.replace(/\/全市/g, '');
            if (param.loadSourceCode) {
              _this2.handingway.filter(function (item) {
                if (item.defineCode == param.loadSourceCode) {
                  param.vsRemark = item.defineValue + ';' + param.vsRemark;
                }
              });
            }
            var params = {
              vsjsondata: JSON.stringify(param),
              vehiclejsondata: JSON.stringify(param)
            };
            var paramete = {
              "version": '1',
              "fun": 'releasepcvs',
              "param": params
            };
            var jsonParamete = {
              jsonParamete: JSON.stringify(paramete)
            };
            _this2.pushCars(jsonParamete);
          }
        });
      }
    },
    pushCars: function () {
      var _pushCars = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(param) {
        var _yield$apiGetPubCarsD, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return (0, _api.apiGetPubCarsData)(param);
            case 2:
              _yield$apiGetPubCarsD = _context5.sent;
              data = _yield$apiGetPubCarsD.data;
              if (data.proCode == '200') {
                this.$router.push({
                  name: 'pubcarsucceed',
                  query: {
                    vsid: data.proData.vsid
                  }
                });
              } else if (data.proCode == '250') {
                this.$message({
                  message: data.proMsg,
                  type: 'error',
                  duration: '1000'
                });
              } else {
                this.$message({
                  message: '发布失败,请重试!',
                  type: 'error',
                  duration: '1000'
                });
              }
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function pushCars(_x) {
        return _pushCars.apply(this, arguments);
      }
      return pushCars;
    }(),
    // 未登录弹出登录窗
    toLogin: function toLogin() {
      var that = this;
      // session替换成cookie
      var userStorage = (0, _cookie.getCookie)('user');
      // let userStorage = window.sessionStorage.getItem('user')
      if (!userStorage) {
        that.$root.dialogFormVisible = true;
      }
    },
    // 判断表单是否填写完整
    canPub: function canPub() {
      var that = this;
      if (that.pubForm.vsOrigin.length > 0 && that.pubForm.vsDestination.length > 0 && that.pubForm.vsContact && that.pubForm.vsCellphone && that.pubForm.cVehicleTypeId) {
        that.isempty = false;
      } else {
        that.isempty = true;
      }
    },
    tabChange: function tabChange(url) {
      this.$router.push({
        name: url
      });
    }
  }
};